import { render, staticRenderFns } from "./TermsModal.vue?vue&type=template&id=a0c6d6d4&scoped=true&"
import script from "./TermsModal.vue?vue&type=script&lang=js&"
export * from "./TermsModal.vue?vue&type=script&lang=js&"
import style0 from "./TermsModal.vue?vue&type=style&index=0&id=a0c6d6d4&scoped=true&lang=sass&"
import style1 from "./TermsModal.vue?vue&type=style&index=1&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0c6d6d4",
  null
  
)

/* custom blocks */
import block0 from "./TermsModal.vue?vue&type=custom&index=0&blockType=i18n&lang=yaml"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a0c6d6d4')) {
      api.createRecord('a0c6d6d4', component.options)
    } else {
      api.reload('a0c6d6d4', component.options)
    }
    module.hot.accept("./TermsModal.vue?vue&type=template&id=a0c6d6d4&scoped=true&", function () {
      api.rerender('a0c6d6d4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/TermsModal.vue"
export default component.exports